import controller from './combined-search-controller';
import template from './combined-search.html';

const CombinedSearchComponent = {
    bindings: {
        resolve: '<'
    },
    controller,
    template
};

export default CombinedSearchComponent;



// WEBPACK FOOTER //
// ./app/components/client-admin/combined-search/combined-search-component.js